import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'stateCount' })
export class StateCountPipe implements PipeTransform {
  transform(states: string[]): string {
    return states.length > 0
      ? `${states.length} ${states.length == 1 ? 'state' : 'states'}`
      : '';
  }
}
